
"use client";

import React from 'react';
import katex from 'katex';
// import 'katex/dist/katex.min.css'; // Se mueve a layout.tsx
import { cn } from "@/lib/utils";

interface KaTeXRendererProps {
  latex: string;
  className?: string;
  displayMode?: boolean;
}

const KaTeXRenderer: React.FC<KaTeXRendererProps> = ({ latex, className, displayMode = false }) => {
  if (typeof latex !== 'string' || latex.trim() === '') {
    return <span className={className}></span>; // Render an empty span for empty or invalid input
  }

  try {
    const html = katex.renderToString(latex, {
      throwOnError: false, // Don't halt rendering on parse error, log to console by KaTeX
      displayMode: displayMode,
      output: 'html', // Ensure HTML output
      maxSize: 5, // Limitar el tamaño máximo para evitar desbordamientos
      maxExpand: 1000,
    });
    // Eliminar overflow-x-auto para evitar scrolls y permitir que el texto se ajuste naturalmente
    return <span className={cn("inline-block", className)} dangerouslySetInnerHTML={{ __html: html }} />;
  } catch (error) {
    console.error("KaTeX rendering error for string:", latex, error);
    // Fallback: display the raw LaTeX string or an error message
    return <span className={cn("inline-block", className)} style={{ color: 'red', fontFamily: 'monospace' }}>{latex}</span>;
  }
};

export default KaTeXRenderer;

